/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
/*
  This file is generated by schemagen.js. Do not edit it directly.
*/
import { z } from 'zod';
import { cloudinaryField } from '../../../../scripts/schemaGenerator/fields/cloudinaryField';
import { jsonEditorField } from '../../../../scripts/schemaGenerator/fields/jsonEditorField';
import { contentStackJSONRichText } from '../../../../scripts/schemaGenerator/fields/rte';
import { fileField } from '../../../../scripts/schemaGenerator/fields/fileField';
import { linkField } from '../../../../scripts/schemaGenerator/fields/linkField';
import '../../../../scripts/schemaGenerator/fields/nullableDefault';
const global_module_title = z.object({
  major: contentStackJSONRichText,
  title: contentStackJSONRichText,
  subtitle: contentStackJSONRichText,
  title_order: z.enum(['major-first', 'minor-first']).nullableDefault().default('major-first'),
  title_full_width: z.boolean().nullableDefault().default(false)
});
const global_accordion_group = z.object({
  alignment: z.enum(['center', 'left']).nullable().default(null),
  module_title: global_module_title.nullableDefault().default({}),
  accordion_items: z.array(z.object({
    heading: z.string().nullableDefault().default(''),
    body: contentStackJSONRichText,
    default_is_expanded: z.boolean().nullableDefault().default(false)
  })).nullableDefault().default([]),
  module_footer: z.object({
    link: linkField.nullableDefault().default({}),
    hide_on_mobile: z.boolean().nullableDefault().default(false),
    button_color: z.enum(['mint', 'navy', 'citrus']).nullableDefault().default('citrus')
  }).nullableDefault().default({})
});
const global_animated_grid = z.object({
  alignment: z.enum(['center', 'left']).nullable().default(null),
  content_background: z.enum(['mint-60', 'white', 'gray-99', 'blue-45', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('mint-60'),
  text_color: z.enum(['blue-45', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  secondary_text_color: z.enum(['blue-45', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  major_title_text_color: z.enum(['blue-45', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  minor_title_text_color: z.enum(['blue-45', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  module_title: global_module_title.nullableDefault().default({}),
  items: z.array(z.object({
    label: contentStackJSONRichText,
    description: contentStackJSONRichText,
    top_image: z.object({
      src: cloudinaryField,
      alt: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    bottom_image: z.object({
      src: cloudinaryField,
      alt: z.string().nullableDefault().default('')
    }).nullableDefault().default({})
  })).nullableDefault().default([]),
  module_footer: z.object({
    link: linkField.nullableDefault().default({}),
    hide_on_mobile: z.boolean().nullableDefault().default(false),
    button_color: z.enum(['mint', 'navy', 'citrus', 'holiday forest', 'holiday grapefruit', 'holiday snow']).nullableDefault().default('citrus')
  }).nullableDefault().default({})
});
const global_business_line_carousel = z.object({
  header: z.object({
    title: z.string().nullableDefault().default(''),
    description: z.string().nullableDefault().default(''),
    description_links: z.array(linkField).nullableDefault().default([])
  }).nullableDefault().default({}),
  business_lines: z.array(z.object({
    image: z.object({
      alt: z.string().nullableDefault().default(''),
      src: cloudinaryField
    }).nullableDefault().default({}),
    link: linkField.nullableDefault().default({})
  })).nullableDefault().default([])
});
const global_content_gallery = z.object({
  layout: z.enum(['short', 'tall']).nullableDefault().default('tall'),
  header: z.object({
    title: z.string().nullableDefault().default(''),
    description: z.string().nullableDefault().default(''),
    description_links: z.array(linkField).nullableDefault().default([])
  }).nullableDefault().default({}),
  text: contentStackJSONRichText,
  top_left_image: z.object({
    source: cloudinaryField,
    alt_text: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  top_right_image: z.object({
    source: cloudinaryField,
    alt_text: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  bottom_left_image: z.object({
    source: cloudinaryField,
    alt_text: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  bottom_right_image: z.object({
    source: cloudinaryField,
    alt_text: z.string().nullableDefault().default('')
  }).nullableDefault().default({})
});
const global_display_carousel = z.object({
  alignment: z.enum(['center', 'left']).nullable().default(null),
  mobile_nav_style: z.enum(['standard', 'dots']).nullableDefault().default('standard'),
  module_title: global_module_title.nullableDefault().default({}),
  major_title_text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  minor_title_text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  background_color: z.enum(['white', 'blue-45', 'mint-60', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('white'),
  slide_width: z.enum(['small', 'medium', 'large']).nullableDefault().default('medium'),
  slide_spacing: z.enum(['standard', 'wide']).nullableDefault().default('standard'),
  mobile_next_slide_preview: z.enum(['standard', 'narrow', 'none']).nullableDefault().default('standard'),
  rounded_corners_on_images: z.boolean().nullableDefault().default(false),
  slides: z.array(z.object({
    image: z.object({
      source: cloudinaryField,
      alt: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    content: z.object({
      text: contentStackJSONRichText,
      text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
      placement: z.enum(['above', 'below']).nullable().default(null)
    }).nullableDefault().default({})
  })).nullableDefault().default([]),
  module_footer: z.object({
    link: linkField.nullableDefault().default({}),
    hide_on_mobile: z.boolean().nullableDefault().default(false),
    button_color: z.enum(['mint', 'navy', 'citrus', 'holiday forest', 'holiday grapefruit']).nullableDefault().default('citrus')
  }).nullableDefault().default({})
});
const global_display_grid = z.object({
  alignment: z.enum(['center', 'left']).nullable().default(null),
  content_background: z.enum(['white', 'gray-99', 'mint-60', 'blue-45', 'forest-60', 'grapefruit-60', 'gray-95']).nullableDefault().default('white'),
  text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  secondary_text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  major_title_text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  minor_title_text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  module_title: global_module_title.nullableDefault().default({}),
  columns: z.object({
    mobile: z.union([z.literal(1), z.literal(2)]).nullableDefault().default(1),
    desktop: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]).nullableDefault().default(3),
    mobile_spacing: z.enum(['standard', 'tight', 'wide', 'none']).nullableDefault().default('standard'),
    desktop_spacing: z.enum(['standard', 'tight', 'wide', 'none']).nullableDefault().default('standard')
  }).nullableDefault().default({}),
  grid_items: z.array(z.object({
    image: z.object({
      source: cloudinaryField,
      alt: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    content: z.object({
      label: contentStackJSONRichText,
      text: contentStackJSONRichText,
      placement: z.enum(['above', 'below']).nullable().default(null)
    }).nullableDefault().default({})
  })).nullableDefault().default([]),
  module_footer: z.object({
    link: linkField.nullableDefault().default({}),
    hide_on_mobile: z.boolean().nullableDefault().default(false),
    button_color: z.enum(['mint', 'navy', 'citrus', 'holiday forest', 'holiday grapefruit', 'holiday snow']).nullableDefault().default('citrus')
  }).nullableDefault().default({})
});
const global_display_media = z.object({
  alignment: z.enum(['center', 'left']).nullable().default(null),
  module_title: global_module_title.nullableDefault().default({}),
  major_title_text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  minor_title_text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  content_background: z.enum(['white', 'blue-45', 'mint-60', 'gray-95', 'gray-99']).nullableDefault().default('white'),
  mobile_media: z.object({
    source: cloudinaryField,
    alt: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  desktop_media: z.object({
    source: cloudinaryField,
    alt: z.string().nullableDefault().default('')
  }).nullableDefault().default({})
});
const global_display_panel = z.object({
  module_title: global_module_title.nullableDefault().default({}),
  media: z.object({
    src: cloudinaryField,
    alt: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  text: contentStackJSONRichText,
  text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  major_title_text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  minor_title_text_color: z.enum(['blue-45', 'mint-60', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  avatar_image: z.object({
    src: cloudinaryField,
    alt: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  attribution: contentStackJSONRichText,
  content_order: z.enum(['mediaFirst', 'textFirst']).nullableDefault().default('mediaFirst'),
  text_center_aligned: z.boolean().nullableDefault().default(false),
  remove_media_zoom: z.boolean().nullableDefault().default(false),
  background_color: z.enum(['white', 'gray-99']).nullable().default(null),
  module_footer: z.object({
    link: linkField.nullableDefault().default({}),
    hide_on_mobile: z.boolean().nullableDefault().default(false),
    button_color: z.enum(['mint', 'navy', 'citrus', 'holiday forest', 'holiday grapefruit', 'holiday snow']).nullableDefault().default('citrus')
  }).nullableDefault().default({})
});
const global_display_split = z.object({
  sticker_label: z.object({
    sticker_label_text: z.string().nullableDefault().default(''),
    sticker_label_variant: z.enum(['citrus', 'mint', 'navy', 'red', 'white']).nullableDefault().default('citrus')
  }).nullableDefault().default({}),
  text: contentStackJSONRichText,
  media: z.object({
    alt: z.string().nullableDefault().default(''),
    src: cloudinaryField
  }).nullableDefault().default({}),
  content_order: z.enum(['mediaFirst', 'textFirst']).nullableDefault().default('mediaFirst'),
  align_content: z.enum(['center', 'left']).nullableDefault().default('left'),
  desktop_content_order: z.enum(['mediaFirst', 'textFirst']).nullableDefault().default('mediaFirst'),
  variant: z.enum(['mint', 'blue', 'grey', 'holiday forest', 'holiday forest citrus', 'holiday grapefruit', 'holiday snow', 'citrus', 'white', 'cerulean']).nullableDefault().default('mint')
});
const global_display_text = z.object({
  section_title: z.string().nullableDefault().default(''),
  text_items: z.array(z.object({
    text: z.string().nullableDefault().default(''),
    family: z.enum(['medium', 'regular']).nullableDefault().default('regular')
  })).nullableDefault().default([]),
  link: linkField.nullableDefault().default({})
});
const global_divider = z.object({
  variant: z.enum(['section', 'statement', 'item', 'subtle']).nullableDefault().default('section')
});
const global_faqs = z.object({
  faq: z.array(z.object({
    question: z.string().nullableDefault().default(''),
    answer: z.string().nullableDefault().default(''),
    link_href: linkField.nullableDefault().default({})
  })).nullableDefault().default([])
});
const global_footer_image_links = z.object({
  title: z.string().nullableDefault().default(''),
  links: z.array(z.object({
    caption: z.string().nullableDefault().default(''),
    href: z.string().nullableDefault().default(''),
    image: z.object({
      alt_text: z.string().nullableDefault().default(''),
      src: cloudinaryField
    }).nullableDefault().default({})
  })).nullableDefault().default([])
});
const global_gallery_hero = z.object({
  items: z.array(z.object({
    minor_title: z.string().nullableDefault().default(''),
    major_title: z.string().nullableDefault().default(''),
    subtitle: contentStackJSONRichText,
    mobile_image: z.object({
      src: cloudinaryField,
      alt: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    desktop_image: z.object({
      src: cloudinaryField,
      alt: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    cta: linkField.nullableDefault().default({})
  })).nullableDefault().default([]),
  media_transition: z.enum(['none', 'zoom']).nullableDefault().default('zoom'),
  title_transition: z.enum(['fade', 'none', 'slide-up']).nullableDefault().default('slide-up'),
  title_display: z.enum(['minor-major', 'title-xlarge']).nullable().default(null),
  content_background_color: z.enum(['gray', 'none', 'white']).nullableDefault().default('gray'),
  layout: z.enum(['full', 'split']).nullableDefault().default('full'),
  mobile_layout_variant: z.enum(['contentFirst', 'mediaFirst', 'contentMediaStacked']).nullableDefault().default('contentFirst'),
  button_color: z.enum(['mint', 'navy', 'citrus', 'holiday forest', 'holiday grapefruit', 'holiday snow']).nullableDefault().default('citrus')
});
const global_get_started_box = z.object({
  title: z.string().nullableDefault().default(''),
  cta: linkField.nullableDefault().default({})
});
const global_headline = z.object({
  headline: z.string().nullableDefault().default('')
});
const global_hero = z.object({
  items: z.array(z.object({
    title: contentStackJSONRichText,
    subtitle: contentStackJSONRichText,
    font_color: z.enum(['white', 'blue-45', 'gray-16', 'forest-60', 'grapefruit-60']).nullableDefault().default('white'),
    media: z.object({
      mobile: z.object({
        src: cloudinaryField,
        alt_text: z.string().nullableDefault().default('')
      }).nullableDefault().default({}),
      desktop: z.object({
        src: cloudinaryField,
        alt_text: z.string().nullableDefault().default('')
      }).nullableDefault().default({})
    }).nullableDefault().default({}),
    cta: linkField.nullableDefault().default({}),
    button_color: z.enum(['mint', 'navy', 'citrus', 'holiday forest', 'holiday grapefruit', 'holiday snow']).nullableDefault().default('citrus'),
    content_background: z.enum(['none', 'white']).nullableDefault().default('none'),
    cta_subtext: contentStackJSONRichText
  })).nullableDefault().default([]),
  mobile_layout_variant: z.enum(['contentFirst', 'mediaFirst', 'contentMediaStacked']).nullableDefault().default('contentMediaStacked'),
  layout: z.enum(['full', 'split']).nullableDefault().default('full'),
  align_content: z.enum(['left', 'top', 'right', 'bottom', 'center']).nullableDefault().default('center'),
  mobile_align_content: z.enum(['left', 'top', 'right', 'bottom', 'center']).nullableDefault().default('center')
});
const global_id_me = z.object({
  signup_type: z.enum(['idme_government_worker_onboarding', 'idme_military_onboarding', 'idme_nurse_onboarding', 'idme_teacher_onboarding']).nullable().default(null)
});
const global_image_content_1up = z.object({
  title: z.string().nullableDefault().default(''),
  items: z.array(z.object({
    title: z.string().nullableDefault().default(''),
    description: z.string().nullableDefault().default('')
  })).nullableDefault().default([]),
  image: z.object({
    src: cloudinaryField,
    alt: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  show_items_divider: z.boolean().nullableDefault().default(false),
  image_placement: z.enum(['left', 'right']).nullableDefault().default('left')
});
const global_image_half_screen_hero = z.object({
  eyebrow: z.string().nullableDefault().default(''),
  title: z.string().nullableDefault().default(''),
  description: z.string().nullableDefault().default(''),
  cta_text: z.string().nullableDefault().default(''),
  cta_href: z.string().nullableDefault().default(''),
  sign_in_url: z.string().nullableDefault().default(''),
  image: z.object({
    alt: z.string().nullableDefault().default(''),
    src: cloudinaryField
  }).nullableDefault().default({}),
  variant: z.enum(['gray', 'mint']).nullable().default(null),
  content_order: z.enum(['textFirst', 'mediaFirst']).nullable().default(null)
});
const global_interactive_carousel = z.object({
  module_title: global_module_title.nullableDefault().default({}),
  module_alignment: z.enum(['left', 'center']).nullableDefault().default('left'),
  slide_width: z.enum(['small', 'medium', 'large']).nullableDefault().default('medium'),
  slides: z.array(z.union([z.object({
    image_slide: z.object({
      src: cloudinaryField,
      alt: z.string().nullableDefault().default(''),
      label: z.string().nullableDefault().default(''),
      href: z.string().nullableDefault().default('')
    })
  }), z.object({
    video_slide: z.object({
      video_src: cloudinaryField,
      video_description: z.string().nullableDefault().default(''),
      label: z.string().nullableDefault().default(''),
      href: z.string().nullableDefault().default('')
    })
  })])).nullableDefault().default([]),
  module_footer: z.object({
    link: linkField.nullableDefault().default({}),
    hide_on_mobile: z.boolean().nullableDefault().default(false),
    button_color: z.enum(['mint', 'navy', 'citrus']).nullableDefault().default('citrus')
  }).nullableDefault().default({})
});
const global_interactive_grid = z.object({
  module_title: global_module_title.nullableDefault().default({}),
  grid_items: z.array(z.object({
    image: z.object({
      source: cloudinaryField,
      alt: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    label: z.string().nullableDefault().default(''),
    href: z.string().nullableDefault().default('')
  })).nullableDefault().default([]),
  module_footer: z.object({
    link: linkField.nullableDefault().default({}),
    hide_on_mobile: z.boolean().nullableDefault().default(false),
    button_color: z.enum(['mint', 'navy', 'citrus']).nullableDefault().default('citrus')
  }).nullableDefault().default({})
});
const global_interactive_image_scroller = z.object({
  content_background: z.enum(['white', 'gray-99', 'mint-60', 'blue-45', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('white'),
  module_title: global_module_title.nullableDefault().default({}),
  images: z.array(z.object({
    src: cloudinaryField,
    alt: z.string().nullableDefault().default('')
  })).nullableDefault().default([]),
  module_footer: z.object({
    link: linkField.nullableDefault().default({}),
    hide_on_mobile: z.boolean().nullableDefault().default(false),
    button_color: z.enum(['mint', 'navy', 'holiday forest', 'holiday grapefruit', 'holiday snow', 'citrus']).nullableDefault().default('citrus')
  }).nullableDefault().default({})
});
const global_interactive_image_scroller_hero = z.object({
  title: contentStackJSONRichText,
  subtitle: contentStackJSONRichText,
  font_color: z.enum(['blue-45', 'forest-60', 'grapefruit-60', 'gray-16', 'white']).nullableDefault().default('blue-45'),
  content_background: z.enum(['white', 'gray-99', 'mint-60', 'blue-45', 'forest-60', 'grapefruit-60']).nullableDefault().default('white'),
  images: z.array(z.object({
    src: cloudinaryField,
    alt: z.string().nullableDefault().default('')
  })).nullableDefault().default([]),
  cta: linkField.nullableDefault().default({}),
  button_color: z.enum(['citrus', 'holiday forest', 'holiday grapefruit', 'holiday snow', 'mint', 'navy']).nullableDefault().default('citrus')
});
const global_logo_grid = z.object({
  header: z.object({
    title: z.string().nullableDefault().default(''),
    description: z.string().nullableDefault().default(''),
    description_links: z.array(linkField).nullableDefault().default([])
  }).nullableDefault().default({}),
  logos: z.array(z.object({
    src: cloudinaryField,
    alt_text: z.string().nullableDefault().default('')
  })).nullableDefault().default([]),
  column_count: z.number().nullableDefault().default(8)
});
const global_media_gallery = z.object({
  major_title_text_color: z.enum(['blue-45', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  minor_title_text_color: z.enum(['blue-45', 'white', 'forest-60', 'grapefruit-60', 'citrus-60']).nullableDefault().default('blue-45'),
  module_title: global_module_title.nullableDefault().default({}),
  items: z.array(z.object({
    media: z.object({
      mobile: z.object({
        src: cloudinaryField,
        alt: z.string().nullableDefault().default('')
      }).nullableDefault().default({}),
      desktop: z.object({
        src: cloudinaryField,
        alt: z.string().nullableDefault().default('')
      }).nullableDefault().default({})
    }).nullableDefault().default({}),
    content: contentStackJSONRichText,
    type: z.enum(['full-bleed', 'media-stacked']).nullableDefault().default('full-bleed')
  })).nullableDefault().default([]),
  module_footer: z.object({
    link: linkField.nullableDefault().default({}),
    hide_on_mobile: z.boolean().nullableDefault().default(false),
    button_color: z.enum(['mint', 'navy', 'citrus', 'holiday forest', 'holiday grapefruit', 'holiday snow']).nullableDefault().default('citrus')
  }).nullableDefault().default({})
});
const global_merch_carousel = z.object({
  header: z.object({
    title: z.string().nullableDefault().default(''),
    description: z.string().nullableDefault().default(''),
    description_links: z.array(linkField).nullableDefault().default([])
  }).nullableDefault().default({}),
  items: z.array(z.object({
    image: z.object({
      src: cloudinaryField,
      alt: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    link: linkField.nullableDefault().default({}),
    top_text: z.string().nullableDefault().default(''),
    bottom_text: z.string().nullableDefault().default(''),
    text_background_color: z.enum(['white']).nullableDefault().default('white')
  })).nullableDefault().default([])
});
const global_module_footer = z.object({
  link: linkField.nullableDefault().default({}),
  hide_on_mobile: z.boolean().nullableDefault().default(false),
  button_color: z.enum(['mint', 'navy', 'citrus', 'holiday forest', 'holiday grapefruit', 'holiday snow']).nullableDefault().default('citrus')
});
const global_promo_banner = z.object({
  headline: z.string().nullableDefault().default(''),
  content: z.string().nullableDefault().default(''),
  cta_text: z.string().nullableDefault().default(''),
  cta_href: z.string().nullableDefault().default(''),
  images: z.array(z.object({
    alt: z.string().nullableDefault().default(''),
    src: cloudinaryField
  })).nullableDefault().default([]),
  variant: z.enum(['teal', 'dark-teal', 'charcoal', 'coastal', 'light-gray']).nullableDefault().default('charcoal')
});
const global_reasons_to_signup = z.object({
  title: z.string().nullableDefault().default(''),
  blocks: z.array(z.object({
    illustration: z.enum(['IllustrationMdHiwStylePreferences', 'IllustrationMdHiwStylistSelections', 'IllustrationMdFreestyleBagsPair', 'IllustrationSmNoCommitmentScissors', 'IllustrationSmValuePropFreeShipping', 'IllustrationSmExpertPick']).nullable().default(null),
    title: z.string().nullableDefault().default(''),
    description: z.string().nullableDefault().default('')
  })).nullableDefault().default([])
});
const global_seo_data = z.object({
  meta_title: z.string().nullableDefault().default('Your Online Personal Stylist | Stitch Fix'),
  meta_description: z.string().nullableDefault().default(''),
  open_graph_title: z.string().nullableDefault().default(''),
  open_graph_description: z.string().nullableDefault().default(''),
  open_graph_image: cloudinaryField,
  meta_robots: z.string().nullableDefault().default(''),
  canonical_url: z.string().nullableDefault().default(''),
  google_validation: z.string().nullableDefault().default(''),
  bing_validation: z.string().nullableDefault().default(''),
  href_lang: z.array(z.object({
    lang: z.string().nullableDefault().default(''),
    href: z.string().nullableDefault().default('')
  })).nullableDefault().default([]),
  json_ld: z.array(z.object({
    entity: jsonEditorField
  })).nullableDefault().default([])
});
const global_share_stylefile = z.object({
  message_title: z.string().nullableDefault().default('Share your StyleFile'),
  message_text: z.string().nullableDefault().default("Check out my StyleFile\u2014it's my unique style personality from Stitch Fix!")
});
const global_shop_category_grid = z.object({
  module_title: global_module_title.nullableDefault().default({}),
  category_id: z.string().nullableDefault().default(''),
  business_line: z.enum(['KIDS', 'MENS', 'WOMENS']).nullableDefault().default('WOMENS'),
  item_limit: z.number().nullableDefault().default(60),
  promo_cards: z.array(z.object({
    variant: z.enum(['mint', 'blue', 'grey', 'holiday forest', 'holiday forest citrus', 'holiday grapefruit', 'holiday snow', 'citrus', 'white', 'cerulean']).nullableDefault().default('mint'),
    image: z.object({
      src: cloudinaryField,
      alt: z.string().nullableDefault().default(''),
      size: z.enum(['small', 'full']).nullableDefault().default('full')
    }).nullableDefault().default({}),
    content: contentStackJSONRichText,
    cta: linkField.nullableDefault().default({}),
    align_content: z.enum(['top', 'center', 'bottom']).nullableDefault().default('center'),
    grid_positions: z.array(z.number()).nullableDefault().default([])
  })).nullableDefault().default([]),
  module_footer: global_module_footer.nullableDefault().default({})
});
const global_shoppable_editorial = z.object({
  title: z.string().nullableDefault().default(''),
  description: z.string().nullableDefault().default(''),
  cover_item: z.object({
    image: z.object({
      src: cloudinaryField,
      alt: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    href: linkField.nullableDefault().default({}),
    product_name: z.string().nullableDefault().default(''),
    product_brand: z.string().nullableDefault().default(''),
    product_price: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  items: z.array(z.object({
    image: z.object({
      src: cloudinaryField,
      alt: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    href: linkField.nullableDefault().default({}),
    product_name: z.string().nullableDefault().default(''),
    product_brand: z.string().nullableDefault().default(''),
    product_price: z.string().nullableDefault().default('')
  })).nullableDefault().default([])
});
const global_simple_image = z.object({
  cloud: cloudinaryField,
  file: fileField.nullableDefault()
});
const global_slim_banner = z.object({
  variant: z.enum(['citrus', 'grapefruit', 'error-dark', 'info-light', 'promo-dark', 'dark', 'forest', 'navy-white', 'navy-citrus']).nullableDefault().default('promo-dark'),
  icon: z.enum(['ERROR', 'FIX_DELIVERY', 'INFORMATION', 'SUCCESS']).nullable().default(null),
  text: z.string().nullableDefault().default(''),
  cta: linkField.nullableDefault().default({}),
  modal: z.object({
    image: z.object({
      src: cloudinaryField,
      alt_text: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    heading: contentStackJSONRichText,
    body: contentStackJSONRichText,
    cta: linkField.nullableDefault().default({})
  }).nullableDefault().default({})
});
const global_sticky_cta = z.object({
  cta: linkField.nullableDefault().default({}),
  button_color: z.enum(['mint', 'navy', 'citrus', 'holiday forest', 'holiday grapefruit', 'holiday snow']).nullableDefault().default('citrus')
});
const global_stylist_module = z.object({
  header: z.string().nullableDefault().default(''),
  description: z.string().nullableDefault().default(''),
  image: z.object({
    src: cloudinaryField,
    alt_text: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  testimonials: z.array(z.object({
    quote: z.string().nullableDefault().default(''),
    source: z.string().nullableDefault().default(''),
    role: z.string().nullableDefault().default('')
  })).nullableDefault().default([])
});
const global_test_global_field = z.object({
  headline: z.string().nullableDefault().default(''),
  blurb: z.string().nullableDefault().default('')
});
const global_testimonials = z.object({
  heading: z.string().nullableDefault().default(''),
  subtitle: z.string().nullableDefault().default(''),
  testimonials: z.array(z.object({
    quote: contentStackJSONRichText,
    attribution: z.string().nullableDefault().default('')
  })).nullableDefault().default([])
});
const global_trigall_hero = z.object({
  mobile_image: z.object({
    src: cloudinaryField,
    alt: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  left_image: z.object({
    src: cloudinaryField,
    alt: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  title: z.string().nullableDefault().default(''),
  description: z.string().nullableDefault().default(''),
  button: linkField.nullableDefault().default({}),
  top_right_image: z.object({
    src: cloudinaryField,
    alt: z.string().nullableDefault().default('')
  }).nullableDefault().default({}),
  bottom_right_image: z.object({
    src: cloudinaryField,
    alt: z.string().nullableDefault().default('')
  }).nullableDefault().default({})
});
const global_triple_block = z.object({
  title: z.string().nullableDefault().default(''),
  block_size: z.enum(['sm', 'md', 'lg']).nullableDefault().default('md'),
  block: z.array(z.object({
    image: z.object({
      src: cloudinaryField,
      alt: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    illustration: z.enum(['IllustrationMdHiwStylePreferences', 'IllustrationMdHiwStylistSelections', 'IllustrationMdFreestyleBagsPair', 'IllustrationSmNoCommitmentScissors', 'IllustrationSmValuePropFreeShipping', 'IllustrationSmExpertPick', 'IllustrationMdFeatureFixes']).nullable().default(null),
    title: z.string().nullableDefault().default(''),
    description: z.string().nullableDefault().default('')
  })).nullableDefault().default([])
});
const global_video_full_bleed_hero = z.object({
  title: z.object({
    title_text: z.string().nullableDefault().default(''),
    title_shadow: z.boolean().nullableDefault().default(false),
    hide_title_from_view: z.boolean().nullableDefault().default(false)
  }).nullableDefault().default({}),
  cta_text: z.string().nullableDefault().default(''),
  cta_href: z.string().nullableDefault().default(''),
  cta_hidden_from_view: z.boolean().nullableDefault().default(false),
  cta_color: z.enum(['citrus', 'holiday forest', 'holiday grapefruit', 'holiday snow', 'mint', 'navy']).nullableDefault().default('navy'),
  content_order: z.enum(['Title/CTA first', 'Video first']).nullable().default(null),
  mobile_video: cloudinaryField,
  tablet_video: cloudinaryField,
  desktop_video: cloudinaryField,
  video_description: z.string().nullableDefault().default(''),
  captions: z.object({
    language: z.enum(['en']).nullableDefault().default('en'),
    label: z.string().nullableDefault().default(''),
    file: cloudinaryField,
    default: z.boolean().nullableDefault().default(false)
  }).nullableDefault().default({}),
  sound_controls: z.boolean().nullableDefault().default(false),
  play_pause_button_size: z.enum(['large', 'small']).nullable().default(null)
});
const global_video_half_screen_hero = z.object({
  eyebrow: z.string().nullableDefault().default(''),
  title: z.string().nullableDefault().default(''),
  description: z.string().nullableDefault().default(''),
  cta_text: z.string().nullableDefault().default(''),
  cta_href: z.string().nullableDefault().default(''),
  sign_in_url: z.string().nullableDefault().default(''),
  mobile_video: cloudinaryField,
  tablet_video: cloudinaryField,
  desktop_video: cloudinaryField,
  video_description: z.string().nullableDefault().default(''),
  captions: z.object({
    language: z.enum(['en']).nullableDefault().default('en'),
    label: z.string().nullableDefault().default(''),
    file: cloudinaryField,
    default: z.boolean().nullableDefault().default(false)
  }).nullableDefault().default({}),
  sound_controls: z.boolean().nullableDefault().default(false),
  variant: z.enum(['gray', 'mint']).nullableDefault().default('mint'),
  content_order: z.enum(['textFirst', 'mediaFirst']).nullable().default(null),
  play_pause_button_size: z.enum(['large', 'small']).nullable().default(null)
});
const about = z.object({
  title: z.string().nullableDefault().default(''),
  seo_data: global_seo_data.nullableDefault().default({}),
  image_half_screen_hero: global_image_half_screen_hero.nullableDefault().default({}),
  content: contentStackJSONRichText,
  executive_team: z.object({
    heading: z.string().nullableDefault().default(''),
    executive_bios: z.array(z.object({
      name: z.string().nullableDefault().default(''),
      title: z.string().nullableDefault().default(''),
      role: z.string().nullableDefault().default(''),
      description: z.string().nullableDefault().default(''),
      image: z.object({
        alt_text: z.string().nullableDefault().default(''),
        src: cloudinaryField
      }).nullableDefault().default({})
    })).nullableDefault().default([])
  }).nullableDefault().default({}),
  board: z.object({
    heading: z.string().nullableDefault().default(''),
    board_bios: z.array(z.object({
      name: z.string().nullableDefault().default(''),
      title: z.string().nullableDefault().default(''),
      role: z.string().nullableDefault().default(''),
      description: z.string().nullableDefault().default(''),
      image: z.object({
        alt_text: z.string().nullableDefault().default(''),
        src: cloudinaryField
      }).nullableDefault().default({})
    })).nullableDefault().default([])
  }).nullableDefault().default({}),
  get_started: global_get_started_box.nullableDefault().default({})
});
const dynamic_ad_hero = z.object({
  title: z.string().nullableDefault().default(''),
  hero: z.object({
    title: contentStackJSONRichText,
    subtitle: contentStackJSONRichText,
    font_color: z.enum(['white', 'blue-45', 'gray-16', 'forest-60', 'grapefruit-60']).nullableDefault().default('blue-45'),
    cta: linkField.nullableDefault().default({}),
    button_color: z.enum(['mint', 'navy', 'citrus', 'holiday forest', 'holiday grapefruit', 'holiday snow']).nullableDefault().default('citrus'),
    align_content: z.enum(['left', 'center', 'right']).nullableDefault().default('left')
  }).nullableDefault().default({})
});
const how_it_works = z.object({
  title: z.string().nullableDefault().default(''),
  seo_data: global_seo_data.nullableDefault().default({}),
  hero: global_trigall_hero.nullableDefault().default({}),
  header: z.object({
    title: z.string().nullableDefault().default(''),
    description: z.string().nullableDefault().default(''),
    description_links: z.array(z.object({
      link: z.object({
        href: z.string().nullableDefault().default(''),
        text: z.string().nullableDefault().default('')
      }).nullableDefault().default({})
    })).nullableDefault().default([])
  }).nullableDefault().default({}),
  how_it_works: z.object({
    title: z.string().nullableDefault().default(''),
    learn_more: z.string().nullableDefault().default(''),
    steps: z.array(z.object({
      title: z.string().nullableDefault().default(''),
      description: z.string().nullableDefault().default(''),
      icon: z.enum(['IntroduceYourself', 'GetStarted', 'BuyWhatYouLove', 'SendBackTheRest', 'LoveYourLook']).nullable().default(null)
    })).nullableDefault().default([])
  }).nullableDefault().default({}),
  testimonials: z.object({
    testimonals: z.array(z.object({
      testimonial: z.object({
        image: z.object({
          src: cloudinaryField,
          alt: z.string().nullableDefault().default('')
        }).nullableDefault().default({}),
        quote: z.string().nullableDefault().default(''),
        label: z.string().nullableDefault().default(''),
        source: z.string().nullableDefault().default(''),
        title: z.string().nullableDefault().default('')
      }).nullableDefault().default({})
    })).nullableDefault().default([])
  }).nullableDefault().default({}),
  objectives: z.object({
    header_props: z.object({
      title: z.string().nullableDefault().default('')
    }).nullableDefault().default({}),
    blocks: z.array(z.object({
      block: z.object({
        title: z.string().nullableDefault().default(''),
        description: z.string().nullableDefault().default('')
      }).nullableDefault().default({})
    })).nullableDefault().default([])
  }).nullableDefault().default({}),
  content_gallery: global_content_gallery.nullableDefault().default({})
});
const landing_page_custom = z.object({
  title: z.string().nullableDefault().default(''),
  url: z.string().nullableDefault().default(''),
  seo_data: global_seo_data.nullableDefault().default({}),
  modules: z.array(z.union([z.object({
    business_line_carousel: global_business_line_carousel
  }), z.object({
    content_block: z.object({
      content: contentStackJSONRichText
    })
  }), z.object({
    content_gallery: global_content_gallery
  }), z.object({
    divider: global_divider
  }), z.object({
    faqs: global_faqs
  }), z.object({
    footer_image_links: global_footer_image_links
  }), z.object({
    get_started: global_get_started_box
  }), z.object({
    image_content_1up: global_image_content_1up
  }), z.object({
    image_half_screen_hero: global_image_half_screen_hero
  }), z.object({
    logo_grid: global_logo_grid
  }), z.object({
    merch_carousel: global_merch_carousel
  }), z.object({
    promo_banner: global_promo_banner
  }), z.object({
    reasons_to_signup: global_reasons_to_signup
  }), z.object({
    shoppable_editorial: global_shoppable_editorial
  }), z.object({
    stylist_module: global_stylist_module
  }), z.object({
    trigall_hero: global_trigall_hero
  }), z.object({
    triple_block: global_triple_block
  }), z.object({
    video_full_bleed_hero: global_video_full_bleed_hero
  }), z.object({
    video_half_screen_hero: global_video_half_screen_hero
  }), z.object({
    id_me: global_id_me
  })])).nullableDefault().default([])
});
const modular_page = z.object({
  title: z.string().nullableDefault().default(''),
  url: z.string().nullableDefault().default(''),
  seo_data: global_seo_data.nullableDefault().default({}),
  dynamic_ad_hero: z.array(dynamic_ad_hero).optional().nullable(),
  modular_blocks: z.array(z.union([z.object({
    slim_banner: global_slim_banner
  }), z.object({
    gallery_hero: global_gallery_hero
  }), z.object({
    hero: global_hero
  }), z.object({
    interactive_image_scroller_hero: global_interactive_image_scroller_hero
  }), z.object({
    video_full_bleed_hero: global_video_full_bleed_hero
  }), z.object({
    display_grid: global_display_grid
  }), z.object({
    display_carousel: global_display_carousel
  }), z.object({
    interactive_grid: global_interactive_grid
  }), z.object({
    interactive_carousel: global_interactive_carousel
  }), z.object({
    display_media: global_display_media
  }), z.object({
    display_panel: global_display_panel
  }), z.object({
    display_split: global_display_split
  }), z.object({
    display_text: global_display_text
  }), z.object({
    accordion_group: global_accordion_group
  }), z.object({
    sticky_cta: global_sticky_cta
  }), z.object({
    animated_grid: global_animated_grid
  }), z.object({
    media_gallery: global_media_gallery
  }), z.object({
    interactive_image_scroller: global_interactive_image_scroller
  }), z.object({
    shop_category_grid: global_shop_category_grid
  }), z.object({
    id_me: global_id_me
  }), z.object({
    shared_hero: z.object({
      shared_hero: z.array(z.object({
        hero: global_hero
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_accordion_group: z.object({
      shared_accordion_group: z.array(z.object({
        accordion_group: global_accordion_group
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_display_carousel: z.object({
      shared_display_carousel: z.array(z.object({
        display_carousel: global_display_carousel
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_display_grid: z.object({
      shared_display_grid: z.array(z.object({
        display_grid: global_display_grid
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_display_panel: z.object({
      shared_display_panel: z.array(z.object({
        display_panel: global_display_panel
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_display_split: z.object({
      shared_display_split: z.array(z.object({
        display_split: global_display_split
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_slim_banner: z.object({
      shared_slim_banner: z.array(z.object({
        slim_banner: global_slim_banner
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_display_media: z.object({
      shared_display_media: z.array(z.object({
        display_media: global_display_media
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_interactive_image_scroller: z.object({
      shared_interactive_image_scroller: z.array(z.object({
        interactive_image_scroller: global_interactive_image_scroller
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_animated_grid: z.object({
      shared_animated_grid: z.array(z.object({
        animated_grid: global_animated_grid
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_media_gallery: z.object({
      shared_media_gallery: z.array(z.object({
        media_gallery: global_media_gallery
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_interactive_carousel: z.object({
      shared_interactive_carousel: z.array(z.object({
        interactive_carousel: global_interactive_carousel
      })).nullableDefault().default([])
    })
  }), z.object({
    shared_interactive_grid: z.object({
      shared_interactive_grid: z.array(z.object({
        interactive_grid: global_interactive_grid
      })).nullableDefault().default([])
    })
  })])).nullableDefault().default([])
});
const onboarding_stylefile = z.object({
  title: z.string().nullableDefault().default(''),
  url: z.string().nullableDefault().default(''),
  testimonials: global_testimonials.nullableDefault().default({})
});
const shared_accordion_group = z.object({
  title: z.string().nullableDefault().default(''),
  accordion_group: global_accordion_group.nullableDefault().default({})
});
const shared_animated_grid = z.object({
  title: z.string().nullableDefault().default(''),
  animated_grid: global_animated_grid.nullableDefault().default({})
});
const shared_display_carousel = z.object({
  title: z.string().nullableDefault().default(''),
  display_carousel: global_display_carousel.nullableDefault().default({})
});
const shared_display_grid = z.object({
  title: z.string().nullableDefault().default(''),
  display_grid: global_display_grid.nullableDefault().default({})
});
const shared_display_media = z.object({
  title: z.string().nullableDefault().default(''),
  display_media: global_display_media.nullableDefault().default({})
});
const shared_display_panel = z.object({
  title: z.string().nullableDefault().default(''),
  display_panel: global_display_panel.nullableDefault().default({})
});
const shared_display_split = z.object({
  title: z.string().nullableDefault().default(''),
  display_split: global_display_split.nullableDefault().default({})
});
const shared_hero = z.object({
  title: z.string().nullableDefault().default(''),
  hero: global_hero.nullableDefault().default({})
});
const shared_interactive_carousel = z.object({
  title: z.string().nullableDefault().default(''),
  interactive_carousel: global_interactive_carousel.nullableDefault().default({})
});
const shared_interactive_grid = z.object({
  title: z.string().nullableDefault().default(''),
  interactive_grid: global_interactive_grid.nullableDefault().default({})
});
const shared_interactive_image_scroller = z.object({
  title: z.string().nullableDefault().default(''),
  interactive_image_scroller: global_interactive_image_scroller.nullableDefault().default({})
});
const shared_media_gallery = z.object({
  title: z.string().nullableDefault().default(''),
  media_gallery: global_media_gallery.nullableDefault().default({})
});
const shared_slim_banner = z.object({
  title: z.string().nullableDefault().default(''),
  slim_banner: global_slim_banner.nullableDefault().default({})
});
const style_sense = z.object({
  title: z.string().nullableDefault().default(''),
  style_sense_id: z.string().nullableDefault().default(''),
  display_name: z.string().nullableDefault().default(''),
  description: z.string().nullableDefault().default(''),
  public_description: z.string().nullableDefault().default(''),
  substyle: z.array(z.string()).nullableDefault().default([]),
  business_line: z.enum(['womens', 'mens']).nullable().default(null),
  color: z.enum(['#DFE6A3', '#595E2D', '#2E6BF2', '#D2E137', '#8DA6DD', '#246358', '#FF5955', '#F3ECD3', '#7D3736', '#86C8BC', '#001E60', '#DCB6B5', '#F0F1F3']).nullable().default(null)
});
const stylefile_sharing_page = z.object({
  title: z.string().nullableDefault().default(''),
  seo_data: global_seo_data.nullableDefault().default({}),
  open_graph_images: z.object({
    mens: cloudinaryField,
    womens: cloudinaryField
  }).nullableDefault().default({}),
  primary_cta: z.object({
    eyebrow: z.string().nullableDefault().default(''),
    link: linkField.nullableDefault().default({}),
    variant: z.enum(['mint', 'navy-mint', 'navy-citrus', 'citrus', 'grey']).nullableDefault().default('navy-mint')
  }).nullableDefault().default({}),
  secondary_cta: z.object({
    eyebrow: z.string().nullableDefault().default(''),
    link: linkField.nullableDefault().default({}),
    variant: z.enum(['mint', 'navy-mint', 'navy-citrus', 'citrus', 'grey']).nullableDefault().default('mint')
  }).nullableDefault().default({}),
  how_it_works: z.object({
    content: contentStackJSONRichText
  }).nullableDefault().default({})
});
export type About = z.infer<typeof about>;
export type DynamicAdHero = z.infer<typeof dynamic_ad_hero>;
export type HowItWorks = z.infer<typeof how_it_works>;
export type LandingPageCustom = z.infer<typeof landing_page_custom>;
export type ModularPage = z.infer<typeof modular_page>;
export type OnboardingStylefile = z.infer<typeof onboarding_stylefile>;
export type SharedAccordionGroup = z.infer<typeof shared_accordion_group>;
export type SharedAnimatedGrid = z.infer<typeof shared_animated_grid>;
export type SharedDisplayCarousel = z.infer<typeof shared_display_carousel>;
export type SharedDisplayGrid = z.infer<typeof shared_display_grid>;
export type SharedDisplayMedia = z.infer<typeof shared_display_media>;
export type SharedDisplayPanel = z.infer<typeof shared_display_panel>;
export type SharedDisplaySplit = z.infer<typeof shared_display_split>;
export type SharedHero = z.infer<typeof shared_hero>;
export type SharedInteractiveCarousel = z.infer<typeof shared_interactive_carousel>;
export type SharedInteractiveGrid = z.infer<typeof shared_interactive_grid>;
export type SharedInteractiveImageScroller = z.infer<typeof shared_interactive_image_scroller>;
export type SharedMediaGallery = z.infer<typeof shared_media_gallery>;
export type SharedSlimBanner = z.infer<typeof shared_slim_banner>;
export type StyleSense = z.infer<typeof style_sense>;
export type StylefileSharingPage = z.infer<typeof stylefile_sharing_page>;
export type ContentStackJSONRichText = z.infer<typeof contentStackJSONRichText>;
export type GlobalModuleTitle = z.infer<typeof global_module_title>;
export type GlobalAccordionGroup = z.infer<typeof global_accordion_group>;
export type GlobalAnimatedGrid = z.infer<typeof global_animated_grid>;
export type GlobalBusinessLineCarousel = z.infer<typeof global_business_line_carousel>;
export type GlobalContentGallery = z.infer<typeof global_content_gallery>;
export type GlobalDisplayCarousel = z.infer<typeof global_display_carousel>;
export type GlobalDisplayGrid = z.infer<typeof global_display_grid>;
export type GlobalDisplayMedia = z.infer<typeof global_display_media>;
export type GlobalDisplayPanel = z.infer<typeof global_display_panel>;
export type GlobalDisplaySplit = z.infer<typeof global_display_split>;
export type GlobalDisplayText = z.infer<typeof global_display_text>;
export type GlobalDivider = z.infer<typeof global_divider>;
export type GlobalFaqs = z.infer<typeof global_faqs>;
export type GlobalFooterImageLinks = z.infer<typeof global_footer_image_links>;
export type GlobalGalleryHero = z.infer<typeof global_gallery_hero>;
export type GlobalGetStartedBox = z.infer<typeof global_get_started_box>;
export type GlobalHeadline = z.infer<typeof global_headline>;
export type GlobalHero = z.infer<typeof global_hero>;
export type GlobalIdMe = z.infer<typeof global_id_me>;
export type GlobalImageContent_1up = z.infer<typeof global_image_content_1up>;
export type GlobalImageHalfScreenHero = z.infer<typeof global_image_half_screen_hero>;
export type GlobalInteractiveCarousel = z.infer<typeof global_interactive_carousel>;
export type GlobalInteractiveGrid = z.infer<typeof global_interactive_grid>;
export type GlobalInteractiveImageScroller = z.infer<typeof global_interactive_image_scroller>;
export type GlobalInteractiveImageScrollerHero = z.infer<typeof global_interactive_image_scroller_hero>;
export type GlobalLogoGrid = z.infer<typeof global_logo_grid>;
export type GlobalMediaGallery = z.infer<typeof global_media_gallery>;
export type GlobalMerchCarousel = z.infer<typeof global_merch_carousel>;
export type GlobalModuleFooter = z.infer<typeof global_module_footer>;
export type GlobalPromoBanner = z.infer<typeof global_promo_banner>;
export type GlobalReasonsToSignup = z.infer<typeof global_reasons_to_signup>;
export type GlobalSeoData = z.infer<typeof global_seo_data>;
export type GlobalShareStylefile = z.infer<typeof global_share_stylefile>;
export type GlobalShopCategoryGrid = z.infer<typeof global_shop_category_grid>;
export type GlobalShoppableEditorial = z.infer<typeof global_shoppable_editorial>;
export type GlobalSimpleImage = z.infer<typeof global_simple_image>;
export type GlobalSlimBanner = z.infer<typeof global_slim_banner>;
export type GlobalStickyCta = z.infer<typeof global_sticky_cta>;
export type GlobalStylistModule = z.infer<typeof global_stylist_module>;
export type GlobalTestGlobalField = z.infer<typeof global_test_global_field>;
export type GlobalTestimonials = z.infer<typeof global_testimonials>;
export type GlobalTrigallHero = z.infer<typeof global_trigall_hero>;
export type GlobalTripleBlock = z.infer<typeof global_triple_block>;
export type GlobalVideoFullBleedHero = z.infer<typeof global_video_full_bleed_hero>;
export type GlobalVideoHalfScreenHero = z.infer<typeof global_video_half_screen_hero>;
export { about, dynamic_ad_hero, how_it_works, landing_page_custom, modular_page, onboarding_stylefile, shared_accordion_group, shared_animated_grid, shared_display_carousel, shared_display_grid, shared_display_media, shared_display_panel, shared_display_split, shared_hero, shared_interactive_carousel, shared_interactive_grid, shared_interactive_image_scroller, shared_media_gallery, shared_slim_banner, style_sense, stylefile_sharing_page };
export { global_module_title, global_accordion_group, global_animated_grid, global_business_line_carousel, global_content_gallery, global_display_carousel, global_display_grid, global_display_media, global_display_panel, global_display_split, global_display_text, global_divider, global_faqs, global_footer_image_links, global_gallery_hero, global_get_started_box, global_headline, global_hero, global_id_me, global_image_content_1up, global_image_half_screen_hero, global_interactive_carousel, global_interactive_grid, global_interactive_image_scroller, global_interactive_image_scroller_hero, global_logo_grid, global_media_gallery, global_merch_carousel, global_module_footer, global_promo_banner, global_reasons_to_signup, global_seo_data, global_share_stylefile, global_shop_category_grid, global_shoppable_editorial, global_simple_image, global_slim_banner, global_sticky_cta, global_stylist_module, global_test_global_field, global_testimonials, global_trigall_hero, global_triple_block, global_video_full_bleed_hero, global_video_half_screen_hero };
export { contentStackJSONRichText };
/**
 * This is a map of the uids fields defined in contentTypes to the uids of the global fields they reference.
 *
 */
export const fieldMap = {
  about: {
    seo_data: 'seo_data',
    image_half_screen_hero: 'image_half_screen_hero',
    get_started: 'get_started_box'
  },
  dynamic_ad_hero: {},
  how_it_works: {
    seo_data: 'seo_data',
    hero: 'trigall_hero',
    content_gallery: 'content_gallery'
  },
  landing_page_custom: {
    seo_data: 'seo_data'
  },
  modular_page: {
    seo_data: 'seo_data'
  },
  onboarding_stylefile: {
    testimonials: 'testimonials'
  },
  shared_accordion_group: {
    accordion_group: 'accordion_group'
  },
  shared_animated_grid: {
    animated_grid: 'animated_grid'
  },
  shared_display_carousel: {
    display_carousel: 'display_carousel'
  },
  shared_display_grid: {
    display_grid: 'display_grid'
  },
  shared_display_media: {
    display_media: 'display_media'
  },
  shared_display_panel: {
    display_panel: 'display_panel'
  },
  shared_display_split: {
    display_split: 'display_split'
  },
  shared_hero: {
    hero: 'hero'
  },
  shared_interactive_carousel: {
    interactive_carousel: 'interactive_carousel'
  },
  shared_interactive_grid: {
    interactive_grid: 'interactive_grid'
  },
  shared_interactive_image_scroller: {
    interactive_image_scroller: 'interactive_image_scroller'
  },
  shared_media_gallery: {
    media_gallery: 'media_gallery'
  },
  shared_slim_banner: {
    slim_banner: 'slim_banner'
  },
  style_sense: {},
  stylefile_sharing_page: {
    seo_data: 'seo_data'
  }
};